import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import { makePostRequest, makeGetRequest, loginRedirect, makePaymentsGetRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'
import { authenticate } from 'utils/authService'

import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

function* login(action) {
  const { email, password, turnstileToken, onError, navigate } = action.payload
  try {
    const tenant = yield makeGetRequest('/v1/tenants/email', {
      params: {
        email: email.trim().toLowerCase()
      },
      headers: {
        'x-tenant-schema': 'master'
      }
    })
    const url = '/v1/users/signin'
    const response = yield makePostRequest(
      url,
      {
        email: email.trim().toLowerCase(),
        password,
        turnstileToken: turnstileToken || undefined
      },
      {
        headers: {
          'x-tenant-schema': tenant ? tenant.tenantId : 'public'
        }
      }
    )

    if (!response) {
      onError?.()
      yield put({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'Incorrect username or password',
          level: 'error'
        }
      })
      return
    }

    authenticate(response)
    loginRedirect(navigate, response)

    yield put({
      type: ACT.LOGIN_SUCCESS
    })
  } catch (error) {
    onError?.()
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue logging in',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchSubscriptions() {
  try {
    const result = yield makePaymentsGetRequest('/v1/subscriptions')

    yield put({
      type: ACT.SUBSCRIPTIONS_FETCH_SUCCESS,
      payload: {
        subscriptions: result
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Subscriptions',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchCreditCardValid() {
  try {
    const { valid, expired } = yield makePaymentsGetRequest('/v1/credit-cards/valid')

    yield put({
      type: ACT.CREDIT_CARD_VALID_FETCH_SUCCESS,
      payload: {
        hasValidCreditCard: valid,
        hasExpiredCreditCard: expired
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Credit Card Information',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchUnpaidInvoices() {
  try {
    const unpaidInvoices = yield makePaymentsGetRequest('/v1/invoices/open')

    yield put({
      type: ACT.UNPAID_INVOICES_FETCH_SUCCESS,
      payload: {
        unpaidInvoices
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Open Invoices',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const loginSagas = [
  takeLatest(ACT.LOGIN_REQUESTED, login),
  takeLatest(ACT.SUBSCRIPTIONS_FETCH_REQUESTED, fetchSubscriptions),
  takeLatest(ACT.CREDIT_CARD_VALID_FETCH_REQUETED, fetchCreditCardValid),
  takeLatest(ACT.UNPAID_INVOICES_FETCH_REQUETED, fetchUnpaidInvoices)
]

export default loginSagas
